<template>
  <div>
    <form class="form" ref="update_password_request">
      <!--begin::Card-->
      <div class="card card-custom">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title">
            <h3 class="card-label font-weight-bolder text-dark">
              تغییر/افزودن گذرواژه
            </h3>
          </div>
          <div class="card-toolbar">
            <button
              type="button"
              class="btn btn-sm btn-primary mr-2"
              @click="request()"
              ref="update_password_request_btn"
            >
              تایید
            </button>
          </div>
        </div>
        <!--end::Header-->
        <div class="card-body">
          <div>
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-alert">
                گذرواژه
              </label>
              <div class="col-lg-9 col-xl-6">
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i
                        class="fa"
                        @click="showPassword = !showPassword"
                        :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']"
                      ></i
                    ></span>
                  </div>
                  <input
                    class="form-control form-control-lg form-control-solid"
                    :type="[showPassword ? 'text' : 'password']"
                    name="password"
                    ref="password"
                    dir="ltr"
                    autocomplete="off"
                  />
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-alert">
                تکرار گذرواژه
              </label>
              <div class="col-lg-9 col-xl-6">
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i
                        class="fa"
                        @click="showConfirmPassword = !showConfirmPassword"
                        :class="[
                          showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'
                        ]"
                      ></i
                    ></span>
                  </div>
                  <input
                    class="form-control form-control-lg form-control-solid"
                    :type="[showConfirmPassword ? 'text' : 'password']"
                    name="password_confirmation"
                    ref="password_confirmation"
                    dir="ltr"
                    autocomplete="off"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <form class="form" ref="update_password_submit" style="display: none">
      <!--begin::Card-->
      <div class="card card-custom">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title">
            <h3 class="card-label font-weight-bolder text-dark">
              تغییر/افزودن گذرواژه
            </h3>
          </div>
          <div class="card-toolbar">
            <button
              type="button"
              class="btn btn-sm btn-primary mr-2"
              @click="submit()"
              ref="update_password_submit_btn"
            >
              ارسال
            </button>
            <button
              type="reset"
              class="btn btn-sm btn-secondary"
              @click="stopTimer"
            >
              بازگشت
            </button>
          </div>
        </div>
        <!--end::Header-->
        <div class="card-body">
          <div class="form-group row">
            <label class="col-xl-3 col-lg-3 col-form-label text-alert">
              کد
            </label>
            <div class="col-lg-9 col-xl-6">
              <input
                name="otp"
                ref="otp"
                class="form-control form-control-solid text-center h-auto p-5 rounded-lg"
                type="text"
              />
            </div>
          </div>
          <div class="text-right">
            <div class="timer">{{ prettyTime(time) }}</div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";
import {
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUBMIT
} from "@/core/services/store/profile.module";

export default {
  name: "ChangePassword",
  data() {
    return {
      off: "off",
      time: 0,
      timer: null,
      showPassword: false,
      showConfirmPassword: false
    };
  },
  mounted() {
    const update_password_request = this.$refs["update_password_request"];
    const update_password_submit = this.$refs["update_password_submit"];

    this.fv = formValidation(update_password_request, {
      fields: {
        password: {
          validators: {
            notEmpty: {
              message: "گذرواژه صحیح نیست."
            }
          }
        },
        password_confirmation: {
          validators: {
            notEmpty: {
              message: "تکرار گذرواژه صحیح نیست."
            },
            identical: {
              compare: () => {
                return this.$refs["password"].value;
              },
              message: "تکرار گذرواژه یکسان نیست."
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
    this.fv2 = formValidation(update_password_submit, {
      fields: {
        otp: {
          validators: {
            notEmpty: {
              message: "کد را وارد کنید"
            },
            regexp: {
              regexp: /[0-9]|[\u06F0-\u06F9]|[\u0660-\u0669]*/i,
              message: "کد صحیح نیست"
            },
            stringLength: {
              min: 6,
              max: 6,
              message: "کد صحیح نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  methods: {
    request() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          const submitButton = this.$refs["update_password_request_btn"];
          this.disableBtn(submitButton);

          this.$store
            .dispatch(UPDATE_PASSWORD_REQUEST, {
              password: this.$refs["password"].value,
              password_confirmation: this.$refs["password_confirmation"].value
            })
            .then(response => {
              this.time = response["expires_after"];
              this.startTimer();
              this.showForm("submit");

              this.enableBtn(submitButton);
            })
            .catch(() => {
              this.enableBtn(submitButton);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به طور صحیح تکمیل نمایید");
        }
      });
    },
    submit() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let otp = this.parseNumbers(this.$refs.otp.value);

          const submitButton = this.$refs["update_password_submit_btn"];
          this.disableBtn(submitButton);

          this.$store
            .dispatch(UPDATE_PASSWORD_SUBMIT, {
              password: this.$refs["password"].value,
              password_confirmation: this.$refs["password_confirmation"].value,
              otp: otp
            })
            .then(() => {
              this.showForm("request");
              this.showMessage("گذرواژه شما با موفقیت تغییر کرد.");
              this.enableBtn(submitButton);
            })
            .catch(() => {
              this.enableBtn(submitButton);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا کد را به طور صحیح وارد نمایید");
          this.isActive = !this.isActive;
        }
      });
    },
    startTimer() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.time > 0) {
            this.time--;
          } else {
            this.stopTimer();
          }
        }, 1000);
      }
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
      this.time = 0;
      this.showForm("request");
    },

    showForm(name) {
      const update_password_request = this.$refs["update_password_request"];
      const update_password_submit = this.$refs["update_password_submit"];

      if (name === "submit") {
        update_password_request.style.display = "none";
        update_password_submit.style.display = "block";
      } else {
        update_password_request.style.display = "block";
        update_password_submit.style.display = "none";
      }
    }
  },
  computed: {
    ...mapGetters(["currentUserPersonalInfo"])
  }
};
</script>
